import axios from 'axios';
import { constructAuthHeaders } from '@utils/constructAuthHeaders';

export const setProfileSettings = ({ apiUrl, payload, token }) => {
  const headers = constructAuthHeaders(token);
  const url = `${apiUrl}/carrier-users/profile`;
  return axios
    .post(url, payload, headers)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
};
